// msapBridge-loader.js?v=6.0.43
const MSAP_DATA_PATH =
    '/wp-content/plugins/mindstore-addon-product/js/modules/data.js?v=1.6.29';

let _instance = null;
let _loaded = false;
let _success = false;

/** Load MSAP instance once, set _success. */
export async function ensureMsap() {
    if (_loaded) return _success;

    try {
        const mod = await import(MSAP_DATA_PATH);
        // Your data.js default exports an instance (with .load)
        if (mod?.default && typeof mod.default.load === 'function') {
            _instance = mod.default;
            _success = true;
        } else if (window?.msap?.addonData && typeof window.msap.addonData.load === 'function') {
            // Optional global fallback if you choose to expose it in the addon plugin
            _instance = window.msap.addonData;
            _success = true;
        } else {
            console.warn('[msap] Hittade ingen giltig addonData-instans i modulen.');
            _instance = null;
            _success = false;
        }
    } catch (err) {
        console.warn('[msap] Kunde inte ladda addonData (plugin avstängt/fil saknas?)', err);
        _instance = null;
        _success = false;
    } finally {
        _loaded = true;
    }
    return _success;
}

/** Question from other modules: is MSAP in place? */
export function isMsapAvailable() {
    return _success;
}

/** Get the instance (may be null if ensureMsap() failed). */
export function getMsapInstance() {
    return _instance;
}

/** Safe helper: returns normalized data or empty structure. */
export async function getNormalizedOrEmpty() {
    const ok = await ensureMsap();
    if (!ok) return { groups: [], termMeta: {}, attributes: {} };
    try {
        return await _instance.load();
    } catch (e) {
        console.warn('[msap] .load() kastade fel – återgår till tom struktur', e);
        return { groups: [], termMeta: {}, attributes: {} };
    }
}